import { render, staticRenderFns } from "./ZipLogo.vue?vue&type=template&id=17f86652&"
import script from "./ZipLogo.vue?vue&type=script&lang=ts&"
export * from "./ZipLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports